import React, { Component } from 'react';
import Comment from '../../../../common/comments/comment.component';
import { MAX_LENGTH } from '../../../../../constants/external-constants'
import { Loading } from '../../../../../components/common/loading';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { manageUserCommentActions } from '../../../../../store/external/manage-user/manage-user-comments.reducer'

class ManageUserCommentsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }

    }

    componentDidMount() {
        const { getManageUserComments, manageUserComments } = this.props;


        getManageUserComments(this.props.employeeId, manageUserComments.pageIndex, 5)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    postComment(attachedFilename, attachedFileData, commentDescription) {
        const { postManageUserComments } = this.props;
        postManageUserComments(this.props.employeeId, attachedFilename, attachedFileData, commentDescription);
    }


    handleDeleteCircuitComments = async (employeeId) => {
        this.setState({ isLoading: true });
        const { deleteManageUserComments, getManageUserComments, resetManageUserComments, manageUserComments } = this.props;

        await deleteManageUserComments(employeeId, this.props.employeeId);
        await resetManageUserComments();
        await getManageUserComments(this.props.employeeId, 1, manageUserComments?.manageUserComments?.length).then(() => {
            this.setState({ isLoading: false })
        });
        this.setState({ show: false })
    }

    handleLoadMore = async () => {
        const { getManageUserComments, manageUserComments } = this.props;
        await getManageUserComments(this.props.employeeId, manageUserComments.pageIndex + 1)
    }

    componentWillUnmount() {
        const { resetManageUserComments } = this.props;
        resetManageUserComments();
    }
    render() {

        if (this.state.isLoading) {
            return <Loading />
        }

        return (
            <>
                <Comment
                    commentList={this.props.manageUserComments.manageUserComments}
                    addCommentAction={this.postComment.bind(this)}
                    deleteCommentAction={this.handleDeleteCircuitComments.bind(this)}
                    maxLength={MAX_LENGTH.limit_500}
                    isManageUserComment={true}

                    //Access Types
                    isReadOnly={this.props.isReadOnly}
                    isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                    isReadAndWrite={this.props.isReadAndWrite} 

                    handleLoadMore={this.handleLoadMore}
                    hasMoreComments={this.props?.manageUserComments?.hasMoreComments}
                />
            </>
        );
    }
}


export default connect(
    state => {
        const { manageUserComments } = state;
        return {
            manageUserComments
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, manageUserCommentActions),
        dispatch
    )
)(ManageUserCommentsComponent); ;